import React from "react";
import Icon from "@ant-design/icons";

const EditOutlineSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
	stroke = "#667085",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M4.16667 15.8333H5.33333L12.5208 8.64579L11.3542 7.47913L4.16667 14.6666V15.8333ZM16.0833 7.43746L12.5417 3.93746L13.7083 2.77079C14.0278 2.45135 14.4203 2.29163 14.8858 2.29163C15.3514 2.29163 15.7436 2.45135 16.0625 2.77079L17.2292 3.93746C17.5486 4.2569 17.7153 4.64246 17.7292 5.09413C17.7431 5.54579 17.5903 5.93107 17.2708 6.24996L16.0833 7.43746ZM14.875 8.66663L6.04167 17.5H2.5V13.9583L11.3333 5.12496L14.875 8.66663ZM11.9375 8.06246L11.3542 7.47913L12.5208 8.64579L11.9375 8.06246Z"
			fill="#344054"
		/>
	</svg>
);
const EditOutlineIcon = (props) => (
	<Icon component={() => <EditOutlineSvg {...props} />} />
);

export default EditOutlineIcon;
